import React, { useContext, useCallback, useMemo } from 'react';
import { FormattedNumber } from 'react-intl';
import styled, { ThemeContext } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import * as d3Geo from 'd3-geo';

const Wrapper = styled.g`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;

function Label({ isVisible, coordinates, quantity, country, zoom, width, height }) {
  const formattedCountry = useCallback(() => {
    const maxLength = 15;

    if (country.length > maxLength) {
      const cuttedString = country.substring(0, maxLength - 3);

      return `${cuttedString}...`;
    }

    return country;
  }, [country]);

  const theme = useContext(ThemeContext);

  const translate = useMemo(() => {
    const { geoPath, ...projections } = d3Geo;

    const proj = projections.geoMercator().translate([width / 2, height / 2]);

    return proj(coordinates);
  }, [coordinates, width, height]);

  return (
    <Wrapper
      width={`${220 / zoom}`}
      height={`${80 / zoom}`}
      x="0"
      y="0"
      transform={`translate(${translate[0]}, ${translate[1]})`}
      isVisible={isVisible}
    >
      <rect
        width={`${20 / zoom}`}
        height={`${20 / zoom}`}
        x={`${10 / zoom}`}
        y={`-${30 / zoom}`}
        fill="white"
        transform="rotate(45)"
      />
      <rect
        width={`${200 / zoom}`}
        height={`${80 / zoom}`}
        x={`${28 / zoom}`}
        y={`-${32 / zoom}`}
        rx={`${5 / zoom}`}
        ry={`${5 / zoom}`}
        fill="white"
      />
      <g>
        <text
          textAnchor="middle"
          fill={themeGet(`colors.grey_600`)({ theme })}
          style={{
            whiteSpace: 'pre',
            fontFamily: 'inherit',
            fontSize: `${24 / zoom}px`,
            fontWeight: 'bold',
            letterSpacing: '0px',
          }}
        >
          <tspan x={`${128 / zoom}`} y={`${5 / zoom}`} dy="0">
            <FormattedNumber value={quantity} />
          </tspan>
        </text>
        <text
          textAnchor="middle"
          fill={themeGet(`colors.grey_600`)({ theme })}
          style={{
            whiteSpace: 'pre',
            fontFamily: 'inherit',
            fontSize: `${20 / zoom}px`,
            letterSpacing: '0px',
          }}
        >
          <tspan x={`${128 / zoom}`} y={`${30 / zoom}`} dy="0">
            {`${formattedCountry()}`}
          </tspan>
        </text>
      </g>
    </Wrapper>
  );
}

export default Label;
